<template>
  <div>
    <nav v-if="isShow" aria-label="Page navigation example" class="d-inline-block">
      <ul class="pagination" style="cursor: pointer">

        <!-- FIRST -->
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <a class="page-link" @click="setPage(1)">
            <!-- <span>First</span> -->
            <i class="fa fa-angle-double-left"></i>
          </a>
        </li>

        <!-- PREVIOUS -->
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <a class="page-link" @click="setPage(currentPage - 1)" aria-label="Previous">
            <!-- <span>Previous</span> -->
            <i class="fa fa-angle-left"></i>
          </a>
        </li>

        <!-- PAGE NUMBERS -->
        <li v-for="page in pages" class="page-item" :class="{ active: currentPage === page }" :key="page">
          <a @click="setPage(page)" class="page-link">{{ page }}</a>
        </li>

        <!-- NEXT -->
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <a class="page-link" @click="setPage(currentPage + 1)" aria-label="Next">
            <!-- <span>Next</span> -->
            <i class="fa fa-angle-right"></i>
          </a>
        </li>

        <!-- LAST -->
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <a class="page-link" @click="setPage(totalPages)">
            <!-- <span>Last</span> -->
            <i class="fa fa-angle-double-right"></i>
          </a>
        </li>

      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Pagination",

  data() {
    return {
      isShow: false,
      currentPage: 1,
      pages: [],
      totalPages: 0,
    };
  },
  props: {
    page: {
      type: Number,
      default: 0,
      validator: (page) => {
        return page >= 0;
      },
    },
    itemsPerPage: {
      default: 30,
      validator: (page) => {
        return page >= 0;
      },
    },
  },
  methods: {
    setPage(page) {
      this.$emit("page-change", page);
      this.setCurrentPage(page);
    },
    setTotalCount(items, itemsPerPage) {
      if (!itemsPerPage) {
        itemsPerPage = this.itemsPerPage;
      }
      this.totalPages = Math.ceil(Number(items) / itemsPerPage);
      if (this.totalPages > 1) {
        this.isShow = true;
        this.setCurrentPage(1);
      } else {
        this.isShow = false;
      }
    },
    setItemsPerPage(itemsPerPage) {
      this.$emit("items-per-page-change", itemsPerPage);
    },
    setCurrentPage(currentPage) {
      this.currentPage = currentPage;
      var startPage, endPage;
      if (this.totalPages <= 7) {
        startPage = 1;
        endPage = this.totalPages;
      } else {
        if (currentPage <= 4) {
          startPage = 1;
          endPage = 7;
        } else if (currentPage + 3 >= this.totalPages) {
          startPage = this.totalPages - 6;
          endPage = this.totalPages;
        } else {
          startPage = currentPage - 3;
          endPage = currentPage + 3;
        }
      }
      this.pages = [];
      for (let i = startPage; i <= endPage; i++) {
        this.pages.push(i);
      }
    },    
    setCurrentPage_old(currentPage) {
      this.currentPage = currentPage;
      var startPage, endPage;
      if (this.totalPages <= 5) {
        startPage = 1;
        endPage = this.totalPages;
      } else {
        if (currentPage <= 3) {
          startPage = 1;
          endPage = 5;
        } else if (currentPage + 2 >= this.totalPages) {
          startPage = this.totalPages - 4;
          endPage = this.totalPages;
        } else {
          startPage = currentPage - 2;
          endPage = currentPage + 2;
        }
      }
      this.pages = [];
      for (let i = startPage; i <= endPage; i++) {
        this.pages.push(i);
      }
    },
  },
};
</script>
